export default __webpack_public_path__ + "static/media/love-letter.5d222e2c.png";